"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineSpendingAndIncome = void 0;
const utils_1 = require("components/QCurrency/utils");
const combineSpendingAndIncome = (incomeForPeriods, spendingForPeriods) => {
    const incomeByPeriods = incomeForPeriods.periods;
    const spendingByPeriods = spendingForPeriods.periods;
    const combinedData = [];
    for (let i = 0; i < incomeByPeriods.size; i += 1) {
        combinedData.push({
            amount: -(incomeByPeriods.get(i).amount + spendingByPeriods.get(i).amount),
            currency: (0, utils_1.getCombinedCurrency)(incomeByPeriods.get(i).period.currency, spendingByPeriods.get(i).currency),
            label: incomeByPeriods.get(i).period.monthLong,
            period: incomeByPeriods.get(i).period,
            shortLabel: incomeByPeriods.get(i).period.monthShort,
            year: incomeByPeriods.get(i).period.year,
            txns: spendingByPeriods.get(i).txns.concat(incomeByPeriods.get(i).txns),
        });
    }
    return combinedData;
};
exports.combineSpendingAndIncome = combineSpendingAndIncome;
